<template>
  <div>
    <div class="overlay-disable-setting" v-if="!canEditPresentation"></div>
    <div class="relative flex justify-items-center align-middle" @click.capture="clickForUserNotPaid()">
      <aha-checkbox
        id="settings-check-audience-admission"
        @change="handleCheckBoxAudienceAdmission"
        v-model="presentation.audienceAdmission.isAudienceAdmission"
        class="mb-3"
        :disabled="isPlanFree && isBeforeCurrentPeriodStart"
      >
        <span>
          {{ $i18nPresenter.t('Require participants to enter information') }}
        </span>
      </aha-checkbox>

      <div class="relative">
        <AhaSvg
          class="mb-1 ml-1 text-base-70"
          name="question"
          v-tooltip="audienceAdmissionTooltip"
        />
      </div>
    </div>
    <p class="text-xs">
      {{ $i18nPresenter.t("Participants' info is collected in the Excel file containing your presentation report.") }}
      {{ $i18nPresenter.t('Please go to:') }}
      <aha-link
        @click="showResultsMenu"
        type="primary"
        variant="primary"
      >
        <span class="text-xs font-bold">{{ $i18nPresenter.t('Results') }}</span>
      </aha-link> {{ $i18nPresenter.t('to download the file.') }}
    </p>
    <div class="mt-3 form-group" v-if="presentation.audienceAdmission.isAudienceAdmission">
      <label class="label-option" for="audience-admission-heading">
        {{ $i18nPresenter.t('Heading') }}
      </label>
      <aha-input
        :maxLength="150"
        :placeholder="$i18nPresenter.t('Your welcome line…')"
        class="mt-2 mb-4"
        id="audience-admission-heading"
        @input="handleOnInput"
        v-model="presentation.audienceAdmission.heading"
      />
      <AdditionalFieldsForm
        @updateAdditionalFields="updateAdditionalFields"
        :limitFields="3"
        type="audienceAdmission"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AdditionalFieldsForm from '@/components-v2/presentation-editor/side-right/AdditionalFieldsForm.vue'

export default {
  components: {
    AdditionalFieldsForm,
  },
  props: {
    handleCheckBoxAudienceAdmission: {
      type: Function,
      default: () => {},
    },
    handleOnInput: {
      type: Function,
      default: () => {},
    },
    updateAdditionalFields: {
      type: Function,
      default: () => {},
    },
    showResultsMenu: {
      type: Function,
      default: () => {},
    },
    clickForUserNotPaid: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      canEditPresentation: (state) => state.canEditPresentation,
    }),
    audienceAdmissionTooltip() {
      return this.$i18nPresenter.t('Show an entry form for the participants to fill in upon joining')
    },
    isBeforeCurrentPeriodStart() {
      return this.$store.state.currentUser.isBeforeCurrentPeriodStart
    },
    isPlanFree() {
      return !this.$store.state.plan || this.$store.state.plan.group === 'free'
    },
  },
}
</script>

<style lang="scss" scoped>
.overlay-disable-setting {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full z-20;
}
.cta-upgrade{
  left: calc(50% - 180px);
}
.icon-pro{
  margin-top: -13px;
}

</style>
